$( document ).ready(function() {
    // Feternity data
    let three_tire_data = $('#three_tire_data').val();
    ToggleSeperatePotInfo();

    if(three_tire_data != undefined){
        three_tire_data = JSON.parse(three_tire_data);

        // Elements selectors
        let schoolSelect = $('#competition_school');
        let fraternitySelect = $('#competition_fraternity');
        let localFraternitySelect = $('#competition_local_fraternity_chapter');

        // School change event
        schoolSelect.on('change', function () {
            populateFraternityOptions($(this).val());
        });

        // Fraternity change event
        fraternitySelect.on('change', function () {
            populateLocalFraternityOptions($(this).val());
        });

        function populateFraternityOptions(school){
            fraternitySelect.find('option:not(:first)').remove();
            localFraternitySelect.find('option:not(:first)').remove();

            for (let i = 0; i < three_tire_data.schools.length; i++) {
                if (three_tire_data.schools[i].name == school){
                    fraternities = three_tire_data.schools[i].fraternities
                    break;
                }
            }
            
            for (let i = 0; i < fraternities.length; i++) {
                fraternitySelect.append('<option value="'+fraternities[i].name+'">'+fraternities[i].name+'</option>');
            }
        };

        function populateLocalFraternityOptions(fraternity) {
            localFraternitySelect.find('option:not(:first)').remove();

            for (let i = 0; i < fraternities.length; i++) {
                if (fraternities[i].name == fraternity){
                    localFraternities = fraternities[i].local_fraternity_chapters
                    break;
                }
            }

            for (let i = 0; i < localFraternities.length; i++) {
                localFraternitySelect.append('<option value="'+localFraternities[i].name+'">'+localFraternities[i].name+'</option>');
            }
        }

        // For admin page
        let school = $('#school').val();
        let fraternity = $('#fraternity').val();
        let localFraternity = $('#local_fraternity_chapter').val();
        if(school){
            populateFraternityOptions(school);
            populateLocalFraternityOptions(fraternity);
            fraternitySelect.val(fraternity);
            localFraternitySelect.val(localFraternity);
        }
    }

    // Copy invite-url
    $('#copyButton').on('click', function() {
        var textToCopy = $('.invite-link').val();
        var tempInput = $('<input>');
        $('body').append(tempInput);
        tempInput.val(textToCopy).select();
        document.execCommand('copy');
        tempInput.remove();
        $('.invite-link').select();

        var tooltip = document.getElementById("copy-tooltip");
        tooltip.style.display = "block";

        setTimeout(function() {
            tooltip.style.display = "none";
        }, 2000); // 5000 milliseconds = 5 seconds
    });

    // Seperate pot
    $('#competition_seperate_regular_season').change(function(){
        ToggleSeperatePotInfo();
    });

    function ToggleSeperatePotInfo(){
        let potDetails = $('.seperate-pot-details');
        let isChecked = $('#competition_seperate_regular_season').prop('checked');
        isChecked ? potDetails.show() : potDetails.hide()
    };

    // Sport change event
    $('.pga_sport').change(function() {
        if ($(this).is(':checked')) {
            $(".sport_details").show();
        } else {
            $(".sport_details").hide();
        }
    });


});

// MLB Tabs
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.nav-tabs-mlb-tab');
  const contents = document.querySelectorAll('.nav-tabs-mlb-content');

  const today_yesterday_tabs = document.querySelectorAll('.today-nav-tabs-mlb-tab-yesterday');
  const today_yesterday_contents = document.querySelectorAll('.today-nav-tabs-mlb-content-yesterday');

  const yesterday_yesterday_tabs = document.querySelectorAll('.yesterday-nav-tabs-mlb-tab-yesterday');
  const yesterday_yesterday_contents = document.querySelectorAll('.yesterday-nav-tabs-mlb-content-yesterday');

  const tomorrow_tabs = document.querySelectorAll('.nav-tabs-mlb-tab-tomorrow');
  const tomorrow_contents = document.querySelectorAll('.nav-tabs-mlb-content-tomorrow');

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });

  today_yesterday_tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      today_yesterday_tabs.forEach(t => t.classList.remove('active'));
      today_yesterday_contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });

  yesterday_yesterday_tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      yesterday_yesterday_tabs.forEach(t => t.classList.remove('active'));
      yesterday_yesterday_contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });

  tomorrow_tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tomorrow_tabs.forEach(t => t.classList.remove('active'));
      tomorrow_contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });
});

// NFL Tabs
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.nav-tabs-nfl-tab');
  const contents = document.querySelectorAll('.nav-tabs-nfl-content');

  const today_yesterday_tabs = document.querySelectorAll('.today-nav-tabs-nfl-tab-yesterday');
  const today_yesterday_contents = document.querySelectorAll('.today-nav-tabs-nfl-content-yesterday');

  const yesterday_yesterday_tabs = document.querySelectorAll('.yesterday-nav-tabs-nfl-tab-yesterday');
  const yesterday_yesterday_contents = document.querySelectorAll('.yesterday-nav-tabs-nfl-content-yesterday');

  const tomorrow_tabs = document.querySelectorAll('.nav-tabs-nfl-tab-tomorrow');
  const tomorrow_contents = document.querySelectorAll('.nav-tabs-nfl-content-tomorrow');

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });

  today_yesterday_tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      today_yesterday_tabs.forEach(t => t.classList.remove('active'));
      today_yesterday_contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });

  yesterday_yesterday_tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      yesterday_yesterday_tabs.forEach(t => t.classList.remove('active'));
      yesterday_yesterday_contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });

  tomorrow_tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tomorrow_tabs.forEach(t => t.classList.remove('active'));
      tomorrow_contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      console.log(this.dataset.tab)
      console.log(target)
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });
});

// NCAAF Tabs
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.nav-tabs-ncaaf-tab');
  const contents = document.querySelectorAll('.nav-tabs-ncaaf-content');

  const today_yesterday_tabs = document.querySelectorAll('.today-nav-tabs-ncaaf-tab-yesterday');
  const today_yesterday_contents = document.querySelectorAll('.today-nav-tabs-ncaaf-content-yesterday');

  const yesterday_yesterday_tabs = document.querySelectorAll('.yesterday-nav-tabs-ncaaf-tab-yesterday');
  const yesterday_yesterday_contents = document.querySelectorAll('.yesterday-nav-tabs-ncaaf-content-yesterday');

  const tomorrow_tabs = document.querySelectorAll('.nav-tabs-ncaaf-tab-tomorrow');
  const tomorrow_contents = document.querySelectorAll('.nav-tabs-ncaaf-content-tomorrow');

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });

  today_yesterday_tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      today_yesterday_tabs.forEach(t => t.classList.remove('active'));
      today_yesterday_contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });

  yesterday_yesterday_tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      yesterday_yesterday_tabs.forEach(t => t.classList.remove('active'));
      yesterday_yesterday_contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });

  tomorrow_tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tomorrow_tabs.forEach(t => t.classList.remove('active'));
      tomorrow_contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      console.log(this.dataset.tab);
      console.log(target);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });
});

// NCAAB Tabs
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.nav-tabs-ncaab-tab');
  const contents = document.querySelectorAll('.nav-tabs-ncaab-content');

  const today_yesterday_tabs = document.querySelectorAll('.today-nav-tabs-ncaab-tab-yesterday');
  const today_yesterday_contents = document.querySelectorAll('.today-nav-tabs-ncaab-content-yesterday');

  const yesterday_yesterday_tabs = document.querySelectorAll('.yesterday-nav-tabs-ncaab-tab-yesterday');
  const yesterday_yesterday_contents = document.querySelectorAll('.yesterday-nav-tabs-ncaab-content-yesterday');

  const tomorrow_tabs = document.querySelectorAll('.nav-tabs-ncaab-tab-tomorrow');
  const tomorrow_contents = document.querySelectorAll('.nav-tabs-ncaab-content-tomorrow');

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });

  today_yesterday_tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      today_yesterday_tabs.forEach(t => t.classList.remove('active'));
      today_yesterday_contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });

  yesterday_yesterday_tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      yesterday_yesterday_tabs.forEach(t => t.classList.remove('active'));
      yesterday_yesterday_contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });

  tomorrow_tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tomorrow_tabs.forEach(t => t.classList.remove('active'));
      tomorrow_contents.forEach(c => {
        c.classList.remove('active');
        c.style.display = 'none';
      });

      this.classList.add('active');
      const target = document.getElementById(this.dataset.tab);
      console.log(this.dataset.tab);
      console.log(target);
      if (target) {
        target.classList.add('active');
        target.style.display = 'block';
      }
    });
  });
});

